<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol>
                    <!-- Title page  -->
                    <h1 class="page__title justify-content">
                        {{ $t(titlePage) }}
                    </h1>
                </CCol>
                <CCol> </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <ButtonBack class="mr-3" title="Go back" />
                            </CCardHeader>
                            <CCardBody>
                                <CContainer fluid>
                                    <CRow>
                                        <CCol>
                                            <CCard>
                                                <CCardHeader>
                                                    <CContainer fluid>
                                                        <CRow>
                                                            <CCol sm="11">
                                                                <h4>
                                                                    {{
                                                                        $t(
                                                                            "Members"
                                                                        )
                                                                    }}
                                                                </h4>
                                                                <p class="mb-0">
                                                                    {{
                                                                        $t(
                                                                            "In the following table you can see what was sent to each member"
                                                                        )
                                                                    }}
                                                                </p>
                                                            </CCol>
                                                            <CCol sm="1">
                                                                <TableSettings
                                                                    :allFields="
                                                                        tables
                                                                            .members
                                                                            .allFields
                                                                    "
                                                                    :activeFields.sync="
                                                                        tables
                                                                            .members
                                                                            .fields
                                                                    "
                                                                />
                                                            </CCol>
                                                        </CRow>
                                                    </CContainer>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CDataTable
                                                        :addTableClasses="[
                                                            'table--sm',
                                                        ]"
                                                        :items="
                                                            tables.members.items
                                                        "
                                                        :fields="
                                                            traslateArrayObjects(
                                                                {
                                                                    array: tables
                                                                        .members
                                                                        .fields,
                                                                    fields: [
                                                                        'label',
                                                                    ],
                                                                }
                                                            )
                                                        "
                                                        :columnFilterValue.sync="
                                                            tables.members
                                                                .columnFilterValue
                                                        "
                                                        @update:column-filter-value="
                                                            updateData()
                                                        "
                                                        @pagination-change="
                                                            itemPerPage
                                                        "
                                                        :items-per-page="
                                                            tables.members.rows
                                                        "
                                                        :sorterValue.sync="
                                                            tables
                                                                .members
                                                                .sorterValue
                                                        "
                                                        @update:sorter-value="
                                                            updateData()
                                                        "
                                                        v-bind="tables.members"
                                                    >
                                                        <template
                                                            #_selected="{
                                                                index,
                                                                item,
                                                            }"
                                                        >
                                                            <td class="py-2">
                                                                <CInputRadio
                                                                    name="_selected"
                                                                    :checked.sync="
                                                                        tables
                                                                            .members
                                                                            .items[
                                                                            index
                                                                        ]
                                                                            ._selected
                                                                    "
                                                                    @update:checked="
                                                                        selectItemTable(
                                                                            'members',
                                                                            item
                                                                        )
                                                                    "
                                                                />
                                                            </td>
                                                        </template>
                                                        <template #over-table>
                                                            <CDropdown
                                                                color="primary"
                                                                :toggler-text="
                                                                    $t(
                                                                        'actions'
                                                                    )
                                                                "
                                                                class="m-2"
                                                                :disabled="
                                                                    tables
                                                                        .members
                                                                        .itemSelected ===
                                                                    null
                                                                "
                                                            >
                                                                <CDropdownItem
                                                                    @click="
                                                                        $router.push(
                                                                            {
                                                                                name: 'delivery_campaign_group_member_leads',
                                                                                params: {
                                                                                    group: uuid,
                                                                                    member: tables
                                                                                        .members
                                                                                        .itemSelected
                                                                                        .uuid,
                                                                                },
                                                                            }
                                                                        )
                                                                    "
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "Leads"
                                                                        )
                                                                    }}
                                                                </CDropdownItem>
                                                                <CDropdownItem
                                                                    @click="
                                                                        $router.push(
                                                                            {
                                                                                name: 'delivery_campaign_group_member_pendings',
                                                                                params: {
                                                                                    group: uuid,
                                                                                    member: tables
                                                                                        .members
                                                                                        .itemSelected
                                                                                        .uuid,
                                                                                },
                                                                            }
                                                                        )
                                                                    "
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "Pendings"
                                                                        )
                                                                    }}
                                                                </CDropdownItem>
                                                            </CDropdown>
                                                        </template>
                                                        <template
                                                            #active="{ item }"
                                                        >
                                                            <td class="py-2">
                                                                <CBadge
                                                                    v-if="
                                                                        stringToBoolean(
                                                                            item.active
                                                                        )
                                                                    "
                                                                    color="success"
                                                                    class="mr-2"
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "active"
                                                                        )
                                                                    }}
                                                                </CBadge>
                                                                <CBadge
                                                                    v-else
                                                                    color="secondary"
                                                                    class="mr-2"
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "stop"
                                                                        )
                                                                    }}
                                                                </CBadge>
                                                            </td>
                                                        </template>
                                                        <template
                                                            #percent_ok="{
                                                                item,
                                                            }"
                                                        >
                                                            <td>
                                                                <ChartGauge
                                                                    :value="
                                                                        calculatePercentage(
                                                                            item.ok,
                                                                            item.sent
                                                                        )
                                                                    "
                                                                    size="sm"
                                                                />
                                                            </td>
                                                        </template>
                                                        <template
                                                            #percent_ko="{
                                                                item,
                                                            }"
                                                        >
                                                            <td>
                                                                <ChartGauge
                                                                    :value="
                                                                        calculatePercentage(
                                                                            item.ko,
                                                                            item.sent
                                                                        )
                                                                    "
                                                                    :reverse="
                                                                        true
                                                                    "
                                                                    size="sm"
                                                                />
                                                            </td>
                                                        </template>
                                                        <template
                                                            #percent_error="{
                                                                item,
                                                            }"
                                                        >
                                                            <td>
                                                                <ChartGauge
                                                                    :value="
                                                                        calculatePercentage(
                                                                            item.error,
                                                                            item.sent
                                                                        )
                                                                    "
                                                                    :reverse="
                                                                        true
                                                                    "
                                                                    size="sm"
                                                                />
                                                            </td>
                                                        </template>
                                                        <template
                                                            #percent_duplicate="{
                                                                item,
                                                            }"
                                                        >
                                                            <td>
                                                                <ChartGauge
                                                                    :value="
                                                                        calculatePercentage(
                                                                            item.duplicate,
                                                                            item.sent
                                                                        )
                                                                    "
                                                                    :reverse="
                                                                        true
                                                                    "
                                                                    size="sm"
                                                                />
                                                            </td>
                                                        </template>
                                                        <template #under-table>
                                                            <div
                                                                class="d-flex justify-content-end"
                                                            >
                                                                <ButtonExport
                                                                    endPoint="/shipment.balancing.api/client-groups/pagination"
                                                                    :table="
                                                                        tables.members
                                                                    "
                                                                />
                                                            </div>
                                                        </template>
                                                    </CDataTable>
                                                </CCardBody>
                                                <CCardFooter
                                                    v-if="
                                                        tables.members
                                                            .total_pages > 0
                                                    "
                                                >
                                                    <div
                                                        class="position-relative"
                                                    >
                                                        <CPagination
                                                            @update:activePage="
                                                                updatePagination
                                                            "
                                                            :activePage="
                                                                tables.members
                                                                    .page
                                                            "
                                                            :pages="
                                                                tables.members
                                                                    .total_pages
                                                            "
                                                            align="center"
                                                        />
                                                        <CElementCover
                                                            :opacity="0.8"
                                                            class="bg-trasparent"
                                                            v-if="
                                                                tables.members
                                                                    .loading
                                                            "
                                                        />
                                                    </div>
                                                </CCardFooter>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                </CContainer>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Components
 */
import ButtonExport from "~/components/ButtonExport";
import ButtonBack from "£lement/ButtonBack";
import FilterDate from "~/components/FilterDate";
import TableSettings from "£lement/TableSettings";
import FilterFields from "~/components/FilterFields";
import ButtonCreate from "~/components/ButtonCreate";
import ChartGauge from "£lement/ChartGauge";

/**
 * Mixins
 */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/**
 * Others
 */
import {
    cilPlus,
    cilSettings,
    cilPencil,
    cilTrash,
    cilArrowThickFromRight,
} from "@coreui/icons";
import ClientGroupMembersStatsTableConfig from "./config/tables/ClientGroupMembersStats.js";

export default {
    name: "DeliveryCampaignGroupDetailPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        TableSettings,
        ButtonBack,
        ButtonExport,
        FilterFields,
        ButtonCreate,
        ChartGauge,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
    },
    data() {
        return {
            tables: {
                members: ClientGroupMembersStatsTableConfig,
            },
        };
    },
    computed: {
        titlePage: function () {
            return this.$route.meta.title
                ? this.$route.meta.title
                : this.$route.name;
        },
        uuid: function () {
            return this.$route.params.uuid;
        },
    },
    watch: {},
    methods: {
        async updateData() {
            this.tables.members.itemSelected = null;
            await this.updateTable({
                tableName: "members",
                url: `/shipment.balancing.api/client-groups/${this.uuid}/members/stats/pagination`,
            });

            this.tables.members.allFields = this.getTableAllFields("members");
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },
    },
    mounted() {
        this.updateData();
    },
};
</script>

<style scoped lang="scss"></style>
